module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Rubik/Rubik-ExtraBold-1ab45dd33fc066882b450c4d5a6cd6c6.ttf";